import { useContext } from 'react';
import { WorkspaceContext } from '@app/Context/WorkspaceContext';

export const acceptedAvatarImageTypes = new Set(['image/png', 'image/jpeg', 'image/jpg']);

export const useWorkspaceContext = () => useContext(WorkspaceContext);
